import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../../styles';
import ButtonSet from '../../ButtonSet';

const styles = css`
  padding: 30px 0;
  background-color: ${colors.neutralLight};
  @media (min-width: 992px) {
    padding: 60px 0;
  }
  .btn {
    width: 100% !important;
  }
`;

function PageIntroBanner({ content }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 mx-lg-auto">
            <ButtonSet buttonSetParent={get(content, '[0]')} />
          </div>
        </div>
      </div>
    </div>
  );
}

PageIntroBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default PageIntroBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ButtonSet.section.js